import React, { useEffect, useState } from "react";
import {
  cardWidgetSample,
  discriptionWidgetSample,
  imageWidgetSample,
  titleWidgetSample,
} from "Utility/Contants/WidgetsContants";
import { useSelector } from "react-redux";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";
import { generateUUID } from "Utility/Common/Methods";
import { updateAccountDetails } from "Sdk/Actions";
import { ActionBar } from "./ActionBar";
import { WidgetRenderer } from "./WidgetRenderer";

function Widgets() {
  const [widgets, setwidgets] = useState([]);

  const userDetails = useSelector(getUserDetailsFromReducer);

  const handleAddWidget = (type) => {
    let obj = {};
    switch (type) {
      case "title":
        obj = { ...titleWidgetSample };
        break;
      case "discription":
        obj = { ...discriptionWidgetSample };
        break;
      case "image":
        obj = { ...imageWidgetSample };
        break;
      case "card":
        obj = { ...cardWidgetSample };
        break;
      default:
        return null;
    }
    obj.isEditing = true;
    obj.id = generateUUID();
    let data = [...widgets, obj];
    setwidgets(data);
    setuuid1(generateUUID());
  };

  const handleEditWidget = ({ index, key, value }) => {
    let data = [...widgets];
    data[index]["isEditing"] = false;
    data[index][key] = value;
    setwidgets(data);
    setuuid1(generateUUID());
  };

  const handleDeleteWidget = (index) => {
    let data = [...widgets];
    data.splice(index, 1);
    setwidgets(data);
    setuuid1(generateUUID());
  };

  const [uuid1, setuuid1] = useState();
  const [uuid2, setuuid2] = useState();

  useEffect(() => {
    setTimeout(() => {
      setuuid2(uuid1);
    }, 3000);
  }, [uuid1]);

  useEffect(() => {
    if (uuid2) handleSaveWidgets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid2]);

  const handleSaveWidgets = async () => {
    if (uuid1 !== uuid2) {
      return;
    }
    try {
      let data = [...widgets];
      data.forEach((item) => delete item?.isEditing);
      let widgetStringified = JSON.stringify(data);
      const userData = {
        username: userDetails?.username,
        widgets: widgetStringified,
      };
      await updateAccountDetails(userData);

      // message.success("Changes saved!");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let widget = userDetails?.widgets;
    if (widget && widget?.length > 0) {
      try {
        let data = JSON.parse(widget);
        setwidgets(data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [userDetails]);

  return (
    <div className="flex flex-col w-full">
      <WidgetRenderer
        username={userDetails?.username}
        widgets={widgets}
        onWidgetEdit={handleEditWidget}
        onWidgetDelete={handleDeleteWidget}
      />
      <ActionBar onAddCard={handleAddWidget} />
    </div>
  );
}

export default Widgets;
